import { extend } from 'vee-validate'

// decimal rule
extend('decimal', {
  params: ['decimals', 'separator'],
  validate: (value: string, { decimals = '*', separator = '.' }: Record<string, any> = {}) => {
    if (value === null || value === undefined || value === '') {
      return {
        valid: false
      }
    }
    if (Number(decimals) === 0) {
      return {
        valid: /^-?\d*$/.test(value)
      }
    }

    const regexPart = decimals === '*' ? '+' : `{1,${decimals}}`
    const regex = new RegExp(`^[-+]?\\d*(\\${separator}\\d${regexPart})?$`)
    return {
      valid: regex.test(value)
    }
  },
  message: 'Pole musi zawierać poprawną wartość zmiennoprzecinkową'
})
